// Gestion de la checkbox d'installation
(function() {
  let isInitialized = false;

  function setupInstallationCheckboxes() {
    const installationCheckboxes = document.querySelectorAll('.installation-checkbox');
    
    installationCheckboxes.forEach(checkbox => {
      // Éviter les doublons
      if (checkbox.dataset.initialized) return;
      checkbox.dataset.initialized = 'true';
      
      console.log('Checkbox trouvée:', checkbox.id);
      
      // Décocher au chargement
      checkbox.checked = false;
      
      checkbox.addEventListener('change', function(e) {
        console.log('Checkbox changée:', this.checked);
        
        // Synchroniser toutes les checkboxes
        const allCheckboxes = document.querySelectorAll('.installation-checkbox');
        allCheckboxes.forEach(cb => {
          cb.checked = this.checked;
        });
        
        // Afficher la popup si cochée
        if (this.checked) {
          showInstallationPopup();
        }
        
        // Mettre à jour l'attribut du panier
        const attributeValue = this.checked ? 'Oui' : null;
        
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              'Installation_sur_place': attributeValue
            }
          })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Attribut mis à jour:', data.attributes);
        })
        .catch(error => {
          console.error('Erreur:', error);
        });
      });
    });
  }

  function showInstallationPopup() {
    console.log('Affichage de la popup');
    
    // Vérifier si une popup existe déjà
    const existingPopup = document.querySelector('.installation-popup');
    if (existingPopup) return;
    
    const overlay = document.createElement('div');
    overlay.className = 'installation-popup-overlay';
    
    const popup = document.createElement('div');
    popup.className = 'installation-popup';
    popup.innerHTML = `
<div class="installation-popup-content">
  <button class="installation-popup-close" aria-label="Fermer">&times;</button>
  <h3>Nos services de livraison</h3>
  <p>Deux options s’offrent à vous :</p>
  <ul>
    <li>🚚 <strong>Livraison à quai (par défaut)</strong> — le matériel est livré devant votre adresse. 
      La mise en place est à votre charge.  
      <br><em>👉 Les frais de livraison indiqués correspondent à cette option.</em></li>
    <li>💪 <strong>Livraison avec manutention (en option)</strong> — notre équipe s’occupe du déchargement et de la mise en place sur site.  
      <br><strong>Cette prestation entraîne des frais supplémentaires.</strong></li>
  </ul>
  <p>✅ <strong>Si vous cochez la case</strong>, cela signifie que vous souhaitez bénéficier de la <strong>livraison avec manutention</strong>, 
  en supplément de la livraison standard à quai.</p>
  <p>Sans précision de votre part, la livraison sera effectuée à quai.</p>
  <p>Une fois votre commande validée, notre équipe vous contactera pour organiser la livraison.</p>
  <p>Merci de votre confiance !</p>
  <button class="installation-popup-button button accent">J'ai compris</button>
</div>

    `;
    
    document.body.appendChild(overlay);
    document.body.appendChild(popup);
    
    setTimeout(() => {
      overlay.classList.add('active');
      popup.classList.add('active');
    }, 10);
    
    function closePopup() {
      overlay.classList.remove('active');
      popup.classList.remove('active');
      setTimeout(() => {
        overlay.remove();
        popup.remove();
      }, 300);
    }
    
    popup.querySelector('.installation-popup-close').addEventListener('click', closePopup);
    popup.querySelector('.installation-popup-button').addEventListener('click', closePopup);
    overlay.addEventListener('click', closePopup);
  }

  // Initialiser au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupInstallationCheckboxes);
  } else {
    setupInstallationCheckboxes();
  }

  // Observer les changements dans le DOM (pour le cart drawer)
  const observer = new MutationObserver(function(mutations) {
    setupInstallationCheckboxes();
  });

  // Observer le body
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  } else {
    window.addEventListener('load', function() {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }

  // Écouter l'événement d'ouverture du cart drawer
  document.addEventListener('cart-drawer:open', setupInstallationCheckboxes);
  
  // Écouter aussi après un délai (au cas où)
  document.addEventListener('click', function(e) {
    if (e.target.closest('[href*="cart"]') || e.target.closest('.cart-link')) {
      setTimeout(setupInstallationCheckboxes, 500);
    }
  });
})();